import React from "react";
import PropTypes from "prop-types";
import { Navigate, useRoutes } from "react-router-dom";
import ALERTS_ICON from "./assets/images/alert-color.svg";
import RealizeAlertsContainer from "./containers/realizeAlertsContainer";
import AlertsSettingContainer from "./containers/alertsSettingContainer";
import AppLayoutContainer from "./containers/appLayoutContainer";
import { useDruvaAlerts } from "./contexts/DruvaAlertsContext";

var SideNavMenuOptions = function SideNavMenuOptions(ALERTS_LIST_PATH) {
  return [{
    name: "Alerts",
    link: "".concat(ALERTS_LIST_PATH, "/list")
  }, {
    name: "Settings",
    link: "".concat(ALERTS_LIST_PATH, "/settings")
  }];
};

var AppRoutes = function AppRoutes(props) {
  var _useDruvaAlerts = useDruvaAlerts(),
      alertsPath = _useDruvaAlerts.apiConfig.alertsPath;

  var routesList = props.routesList;
  var routes = routesList || useRoutes([{
    path: "/",
    element: /*#__PURE__*/React.createElement(AppLayoutContainer, {
      sideBarMenus: SideNavMenuOptions(alertsPath),
      sideBarSite: {
        name: "Alerts",
        icon: ALERTS_ICON
      }
    }),
    children: [{
      path: "/",
      element: /*#__PURE__*/React.createElement(Navigate, {
        to: "".concat(alertsPath, "/list"),
        replace: true
      })
    }, {
      path: "/list",
      element: /*#__PURE__*/React.createElement(RealizeAlertsContainer, null)
    }, {
      path: "/settings",
      element: /*#__PURE__*/React.createElement(AlertsSettingContainer, null)
    }]
  }]);
  return routes;
};

AppRoutes.propTypes = {
  routesList: PropTypes.array
};
export default AppRoutes;